"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRightChild = exports.StyledLeftChild = exports.StyledTextLabel = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledTextLabel = styled_components_1.default.label(__assign(__assign({}, theme_1.font), { WebkitTapHighlightColor: theme_1.colors.transparent, alignItems: 'center', display: 'flex', outline: 'none', position: 'relative', width: '100%' }));
exports.StyledLeftChild = styled_components_1.default.span({
    marginRight: theme_1.scaffolding.sm,
});
exports.StyledRightChild = styled_components_1.default.span({
    marginLeft: theme_1.scaffolding.sm,
});
//# sourceMappingURL=styles.js.map